import { render, staticRenderFns } from "./myproject.vue?vue&type=template&id=85c26300"
import script from "./myproject.vue?vue&type=script&lang=js"
export * from "./myproject.vue?vue&type=script&lang=js"
import style0 from "./myproject.vue?vue&type=style&index=0&id=85c26300&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports